import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-help-versao',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './help-versao.component.html',
  styleUrl: './help-versao.component.css'
})
export class HelpVersaoComponent {
  versaoAtual = 'v91.4.7';
  itens = [
    'Base preservada da v91.4.6.',
    'Módulo Analítico, Relatórios, Administração e Help padronizados como menus principais com submenus recolhíveis.',
    'A proposta de honorários passou a puxar o perito principal vinculado na aba Equipe.',
    'Regra de negócio: cada perícia pode ter somente um profissional com papel Perito.',
    'Preview e exportações de honorários exibem nome, registro, e-mail e telefone do perito cadastrado.',
    'Para trocar o perito da perícia, remova o vínculo atual e cadastre outro profissional como Perito.'
  ];
}
